import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { Icon, FloatingMenu, MenuItem, Row, Text, ContentPlaceholder } from '@evertel/web/ui'
import { ProfilePic } from '@evertel/web/user'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { LogoutService } from '@evertel/session/LogoutService'
import { CurrentUserController } from '@evertel/blue-user'

const HeaderProfileDropdown = observer(({
    ...props
}) => {

    const sessionService = useService(SessionService, [])
    const logoutService = useService(LogoutService, [])
    const currentUserController = useService(CurrentUserController, [sessionService?.currentUserId])

    const user = currentUserController.user

    const placeholderContent = () => {
        return (
            <Row valign="center" style={{ opacity: 0.2 }}>
                <ContentPlaceholder
                    className="me-1"
                    width={60}
                    height={18}
                />
                <ContentPlaceholder
                    className="me-2"
                    width={60}
                    height={18}
                />
                <Icon
                    name="caret-down"
                    color="muted"
                    type="solid"
                    size={10}
                    className="me-2"
                />
                <ContentPlaceholder
                    width={30}
                    height={30}
                />
            </Row>
        )
    }

    const normalContent = useMemo(() => {
        return (
            <Row valign="center">
                <Text
                    className="hidden-mobile me-1 mt-1">
                    {currentUserController.fullName}
                </Text>
                <Icon
                    name="caret-down"
                    color="muted"
                    type="solid"
                    size={10}
                    className="me-2"
                />
                <ProfilePic
                    userId={user?.id as number}
                    width={30}
                    height={30}
                />
            </Row>
        )
    }, [user?.publicImage, user?.firstName, user?.lastName, user?.id, currentUserController.fullName])

    return (
        <FloatingMenu
            id="header-dropdown-profile-settings-menu"
            label="Profile Settings Menu"
            title="Profile Settings Menu"
            aria-label="Profile Settings Menu"
            className="me-3"
            renderLabel={() => !user ? placeholderContent() : normalContent}
        >
            <MenuItem
                label="My Profile"
                icon={{ name: 'user' }}
                to={`/account/profile/${currentUserController.user?.id}`}
            />
            <MenuItem
                label="Preferences"
                icon={{ name: 'sliders-h' }}
                to="/account/preferences"
            />
            <MenuItem
                label="Security"
                icon={{ name: 'lock' }}
                to="/account/security"
            />
            <MenuItem
                label="Notifications"
                icon={{ name: 'bell' }}
                to="/account/notifications"
            />
            <MenuItem
                label="My Agencies"
                icon={{ name: 'list-alt' }}
                to="/account/departments"
            />
            <MenuItem
                label="My Agreements"
                icon={{ name: 'file-contract' }}
                to="/account/agreements"
            />
            <MenuItem
                label="Logout"
                icon={{ name: 'sign-out-alt' }}
                onClick={() => logoutService.logout('manual')}
                className="text-danger"
            />
            <MenuItem
                label="Logout on all my devices"
                icon={{ name: 'mobile-alt' }}
                onClick={() => logoutService.logoutAllDevices('manual')}
            />
        </FloatingMenu>
    )
})

export { HeaderProfileDropdown }
